import { useMetricHydration } from "./useMetricHydration";
import { useIncomeStatementData } from "./sections/useIncomeStatementData";
import { useBalanceSheetData } from "./sections/useBalanceSheetData";
import { useCapitalStructureData } from "./sections/useCapitalStructureData";
import { usePostClosingMetricsData } from "./sections/usePostClosingMetricsData";
import { useProjectedFinancialsM05Data } from "./sections/useProjectedFinancialsM05Data";
import { useProjectedFinancialsData } from "./sections/useProjectedFinancialsData";

/**
 * Main orchestrator hook for Financial Highlights data
 * Delegates to specialized section hooks for better organization
 */
export function useFinancialHighlightsData() {
    useMetricHydration();

    const incomeStatementData = useIncomeStatementData();
    const balanceSheetData = useBalanceSheetData();
    const capitalStructureData = useCapitalStructureData();
    const postClosingMetricsData = usePostClosingMetricsData();
    const projectedFinancialsData = useProjectedFinancialsData();
    const projectedFinancialsM05Data = useProjectedFinancialsM05Data();

    return {
        incomeStatementData,
        balanceSheetData,
        capitalStructureData,
        projectedFinancialsData,
        projectedFinancialsM05Data,
        postClosingMetricsData,
    };
}
